'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PrivacyStatement = function PrivacyStatement() {
  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    lineHeight: "1"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "100"
  }, "Tyro Health collects your email, mobile, personal details, health fund and payment information to process claims and payments. See our", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
    href: "https://www.tyrohealth.com/privacy/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "privacy policy"), ' ', "for details on how we protect your information.", ' '));
};

exports["default"] = PrivacyStatement;
